import "dotenv/config"; // Loads env variables

import { envSchema } from "./schemas";

export const env = envSchema.parse(process.env);

export default env;
